'use client';

import Link from 'next/link';
import { useTranslations } from 'next-intl';

import { TableOfContentsItem } from '../../types';

import { styles } from './TableOfContents.styles';

interface TableOfContentsProps {
  items: TableOfContentsItem[];
  onItemClick?: (id: string) => void;
  className?: string;
}

export function TableOfContents({
  items,
  onItemClick,
  className
}: TableOfContentsProps) {
  const slots = styles();

  const t = useTranslations();

  return (
    <div className={slots.base({ className })}>
      <h2 className={slots.title()}>{t('tableOfContents')}</h2>
      <ul
        className={slots.list()}
        itemScope
        itemType="https://schema.org/ItemList"
      >
        {items.map((item, index) => (
          <li
            key={item.id}
            itemProp="itemListElement"
            itemScope
            itemType="https://schema.org/ListItem"
          >
            <Link
              href={`#${item.id}`}
              className={slots.itemLink()}
              onClick={() => onItemClick?.(item.id)}
              itemProp="name"
            >
              {index + 1}. {item.title}
            </Link>
            <meta
              itemProp="position"
              content={String(index + 1)}
            />
          </li>
        ))}
      </ul>
    </div>
  );
}
